import { TBuilderChatOnboardingType } from 'shared/types/chatOnboarding';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export enum EChatOnboardingActionTypes {
  ForceBuilderOnboardingClosing = 'Chat/ForceBuilderOnboardingClosing',
}

export const forceBuilderOnboardingClosing = actionGenerator<
  EChatOnboardingActionTypes.ForceBuilderOnboardingClosing,
  TBuilderChatOnboardingType
>(EChatOnboardingActionTypes.ForceBuilderOnboardingClosing);

export type TChatOnboardingActions = ReturnType<typeof forceBuilderOnboardingClosing>;
